<template>
  <tr v-if="showRow">
    <td>{{member.created_at|dateFormat('YYYY/MM/DD HH:mm')}}</td>
    <td>{{member.member_id}}</td>
    <td>{{member.mail}}</td>
    <td>{{member.is_notice_name}}</td>
    <td>
      <router-link :to="'/member/edit/' + member.member_id">{{member.name}}</router-link>
    </td>
    <td>
      <template v-if="member.count_public_review">
        <router-link :to="'/company/review?is_public=1&member_id=' + member.member_id">
          <label class="label label-info">
            公開中({{member.count_public_review}}件)
          </label>
        </router-link>
      </template>
    </td>
    <td>
      <template v-if="member.count_private_review">
        <router-link :to="'/company/review?is_public=0&member_id=' + member.member_id">
          <label class="label label-warning">
            公開前({{member.count_private_review}}件)
          </label>
        </router-link>
      </template>
    </td>
    <td>
      <router-link :to='"/company/review/create?member_id="+member.member_id'>
        <button class="btn btn-info btn-outline btn-xs btn-bitbucket">
          口コミ作成
        </button>
      </router-link>
<!--      <button class="btn btn-xs disabled">削除</button>-->
    </td>
  </tr>
</template>
<script>
  export default {
    props: ['member'],
    data: function () {
      return {
        errors: false,
        showRow: true,
        showModal: false
      }
    },
    methods: {
      deleteMember: function () {
        this.$emit('showModal', this.member)
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// ListRow.vue?77e52110